"use client";

import { useState } from "react";
import Link from "next/link";
import { useCart } from "../../../data/CartContext";
import { track } from "../../../lib/track";

export default function AddToCartButton({ id, title, price }: { id: string; title: string; price: string }) {
  const { addToCart } = useCart();
  const [showNote, setShowNote] = useState(false);
  const numericPrice = Number(String(price).replace(/[^\d.-]/g, "")) || 0;

  const handleAddToCart = () => {
    addToCart({ id, title, price, qty: 1, totalPrice: numericPrice });
    track(
      "add_to_cart",
      { label: `Added 1 × ${title}`, component: "BundleDetailPage" },
      { event: "add_to_cart", label: `Added 1 × ${title}`, component: "BundleDetailPage", meta: { timestamp: Date.now() } }
    );
    setShowNote(true);
    setTimeout(() => setShowNote(false), 4000);
  };

  return (
    <div>
      <button
        onClick={handleAddToCart}
        className="w-full bg-amber-500 hover:bg-amber-400 text-white font-bold py-4 px-8 rounded-xl text-lg transition shadow-lg"
      >
        Add to Cart — {price}
      </button>
      {showNote && (
        <p className="mt-3 text-sm text-center text-white/80">
          Added to cart.{" "}
          <Link href="/shop/cart" className="underline font-medium text-white">
            View cart →
          </Link>
        </p>
      )}
    </div>
  );
}
